var React = require('react');

function Business (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34.5714 14.1428H9.4285C7.69275 14.1428 6.28564 15.5499 6.28564 17.2857V33C6.28564 34.7357 7.69275 36.1428 9.4285 36.1428H34.5714C36.3071 36.1428 37.7142 34.7357 37.7142 33V17.2857C37.7142 15.5499 36.3071 14.1428 34.5714 14.1428Z","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M28.2858 36.1429V11C28.2858 10.1665 27.9547 9.3671 27.3653 8.7777C26.7759 8.1883 25.9765 7.85718 25.1429 7.85718H18.8572C18.0237 7.85718 17.2243 8.1883 16.6349 8.7777C16.0455 9.3671 15.7144 10.1665 15.7144 11V36.1429","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Business.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Business;

Business.default = Business;
